import styled from 'styled-components';

const GrowthIcon = styled.img`
  margin-right: 10px;
`;

export default GrowthIcon;
